// TODO - split removal : remove this hook and related code reference
export const usePackagePageV2Analytics = () => true;
